import { useState, useEffect } from 'react'
import { getSiteByIdService } from '../services/configurationServices';

export const useSiteById = () => {

    const [site, setSite] = useState([]);

    const getSite = (id) => {
        getSiteByIdService(id)
            .then((res) => {
                if (res.Status == "success") {
                    setSite(res.Data)
                } else {
                    setSite([])
                }
            })
            .catch(err => {
                setSite([])
            })
    }

    return { site, setSite, getSite }

}